import Scenario5Part1 from './Scenario5Part1';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { CalmBaseScenario } from '../CalmBaseScenario';
import Scenario5Part2 from './Scenario5Part2';
import Scenario5Part3 from './Scenario5Part3';
import Scenario5Part4 from './Scenario5Part4';
import Scenario5Part5 from './Scenario5Part5';
import Scenario5Part6 from './Scenario5Part6';
import Scenario5Part7 from './Scenario5Part7';
import Scenario5Part8 from './Scenario5Part8';
import Scenario5Part9 from './Scenario5Part9';
import { KnowledgeCheckUIConfig } from '../../components/ui/KnowledgeCheckUI';

export default class Scenario5 extends CalmBaseScenario {
	parts: BaseScenarioPart<CalmBaseScenario>[] = [
		new Scenario5Part1(this, () => {this.goToPart2()}),
		new Scenario5Part2(this, () => {this.goToPart3()}),
		new Scenario5Part3(this, () => {this.goToPart4()}),
		new Scenario5Part4(this, () => {this.goToPart5()}),
		new Scenario5Part5(this, () => {this.goToPart7()}),		// WE'RE SKIPPING SIX BECAUSE NO EVENTS NEED TO OCCUR
		new Scenario5Part6(this, () => {this.goToPart7()}),
		new Scenario5Part7(this, () => {this.goToPart8()}),
		new Scenario5Part8(this, () => {this.goToPart9()}),
		new Scenario5Part9(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public getEnvironmentProps(): VideoEnvironmentProps {
		return {
			controls: false,			
			autoBlur: true
		};
	}

	public get currentLevel(): number {
		return 4;
    }
	
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<CalmBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario5/' + fileName + '.mp3';
	}

	start() {
		this.resetAAR();
       this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		// this.showAar(0, () => {});
		// this.testAar();
		// this.showKnowledgeCheck((config: KnowledgeCheckUIConfig) => {
		// 	for (var indx = 0; indx < config.questions.length; indx++) {
		// 		var q = config.questions[indx];
		// 		var scenarioID = 0;
		// 		var sectionId = 0;
		// 		var allCorrectChoices = q.choices.filter(c => c.isCorrect);
		// 		var allSelectedCorrectChoices = q.choices.filter(c => c.isCorrect && c.isSelected);
		// 		var isCorrect = allCorrectChoices.length === allSelectedCorrectChoices.length;
		// 		if(q.title.startsWith('An in-patient was')) {
		// 			scenarioID = 0;
		// 			sectionId = 3;
		// 		} else if(q.title.startsWith('Patient was discharged')) {
		// 			scenarioID = 2;
		// 			sectionId = 2;
		// 		} else if(q.title.startsWith('Interpreter services were ')) {
		// 			scenarioID = 3;
		// 			sectionId = 2;
		// 		}

		// 		var s = q.choices.map((cs, i) => {
		// 			if(cs.isSelected) {
		// 				return i;
		// 			} else {
		// 				return -1;
		// 			}
		// 		});

		// 		this.evaluateAnswerForSummative({
		// 			text: '',
		// 			isCorrect: isCorrect
		// 		}, {
		// 			onOptionSelected: () => {},
		// 			options: [
		// 				{
		// 					text: '',
		// 					isCorrect: true
		// 				},
		// 				{
		// 					text: '',
		// 					isCorrect: false
		// 				}
		// 			],
		// 			aarScenarioID: scenarioID,
		// 			aarSectionID: sectionId,
		// 			selectedAnswer: 0,
		// 			aarCollectionID: s.filter(sf => sf !== -1) 
		// 		}, () => {}, 0)
		// 	}

		// 	this.destroyAllUIInstances();
		// 	this.testAar();

		// })	// END OF SUMMATIVE KNOWLEDGE CHECK, FOLLOWED BY AAR
		this.goToPart1();	
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part1.id, () => {
			this.destroyAllUIInstances();
		});
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part2.id);
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part3.id);
	}

	goToPart4() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part4.id);
	}

	goToPart5() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part5.id);
	}

	goToPart6() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part6.id);
	}

	goToPart7() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part7.id);
	}

	goToPart8() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part8.id);
	}

	goToPart9() {
		this.loadPart(constants.scenarios.scenario5.parts.level5Part9.id);
	}

	goToScenarioEnd() {
	}
}